export const Disconnected = () => (
    <div className="uk-modal-body om-body">
        <h2><i className="fas fa-unlink"></i> Hemos perdido la conexión con el servidor</h2>
        <div className="info-box-alt" style={{margin: "1rem"}}>
            <div>Estamos intentando establecer una nueva conexión segura...</div>
            <div className="om-cycle-progress"></div>
        </div>
        <p style={{textAlign: 'justify'}}>Te avisaremos cuando podamos establecer de nuevo una conexión segura con el servidor.</p>
    </div>
)